/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-12 10:33:07
 * @LastEditors: lihuiping lihuiping@yuouhui.com
 * @LastEditTime: 2023-12-15 16:05:34
 * @FilePath: /mzc-frontend-pc/packages/share/utils/btnPermission.ts
 * @Description:按钮权限逻辑
 *
 */
import { Ref, ref } from "vue";
type btnUnionType = "新增" | "编辑" | "状态" | "删除" | "批量停用" | "批量启用" | "批量删除" | "导出" | "变更" | "审核" | "作废" | "强制结束" | "隐藏评价" | "废弃" | "平台审核" | "开通账号" | "解绑" | "等级调整" | "批量发货";
//是否有按钮权限
function useBtnPermission(btnName: btnUnionType): boolean {
  let hasBtnPermission = false;
  let localBtnListCache = localStorage.getItem("btnList");
  if (localBtnListCache) {
    let btnList = JSON.parse(localBtnListCache);
    hasBtnPermission = Boolean(btnList.filter((item: string) => item === btnName).length);
  }
  return hasBtnPermission;
}

// 获取当前页面按钮权限列表    //     1: "列表", 2: "新增", 3: "编辑", 4: "详情",5: "弹窗",
type btnType = 1 | 2 | 3 | 4 | 5;

function getBtnListByBtnType(type: btnType): Array<string> {
  let localAllBtnListCache = localStorage.getItem("allBtnList");
  if (localAllBtnListCache) {
    let allBtnList = JSON.parse(localAllBtnListCache);
    return allBtnList.filter((item: any) => item.actionType == type).map((item: any) => item.name);
  }
  return [""];
}

export { useBtnPermission, getBtnListByBtnType };
